import { useQuery, UseQueryResult } from 'react-query'
import request from '../../request'
import { useDealership } from '../../../store/zustand/dealershipStore'

type ResultType = {
  profile_type: number
}

export const useGetDealerProfileLayout = (): UseQueryResult<ResultType, Error> => {
  const dealership = useDealership()
  return useQuery<ResultType, Error>(
    ['dealer', dealership?.id, 'profile', 'layout'],
    () =>
      request<ResultType>({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/profile/layout`,
        method: 'GET',
      }),
    { enabled: !!dealership?.id },
  )
}
